import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { GovtManageSchemesComponent } from '../govt-manage-schemes/govt-manage-schemes.component';
import { VideoCategoryManageComponent } from '../video-category-manage/video-category-manage.component';


@Component({
  selector: 'app-post-a-video',
  templateUrl: './post-a-video.component.html',
  styleUrls: ['./post-a-video.component.scss'],
  providers: [DatePipe]
})
export class PostAVideoComponent implements OnInit {
  form: FormGroup;
  videoList;
  categorydata; categorydatalist;
  disable = false;
  submitted = false;
  response;
  categoryID

  languageList = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];
  constructor(private datepipe: DatePipe, private router: Router, private spinner: NgxSpinnerService,
    private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private dialog: MatDialog) { }

  ngOnInit() {
    this.form = this.fb.group({
      Title: ['', [Validators.required]],
      Description: ['', [Validators.required]],
      VideoURL: [''],
      Source: [''],
      videoId: [''],
      languages:[''],
      CategoryID: ['', [Validators.required]],
      PublishDate: [new Date()]

    });
    this.getcategoryforFilter();
  }
  getcategoryforFilter() {
    this._userService.getVideoCategory().subscribe(data => {
      this.categorydata = data
      this.categorydatalist = this.categorydata.result.data
    });
  }
  getcategory(categoryID) {
    this.categoryID = categoryID
  }
  listPage() {
    this.router.navigate(['video-library']);
  }
  get f() { return this.form.controls; }
  //*****************************post a video********************************* 
  onSubmit() {
    this.submitted = true
    this.spinner.show()
    if (this.form.valid) {
      this.spinner.show()
      let text = confirm("Are you sure you want to publish this video ?");
      if (text == true) {
        this.form.value.languages = [this.form.value.languages];
        this._userService.postVideo(this.form.value).subscribe(data => {
          this.response = data;
          this.spinner.hide()
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
        });
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/post-a-video']);
          this.spinner.hide()
        });
      } else {
        this.spinner.hide()
      }
    }
    else {
      this.toastr.error("Please fill the form")
      this.spinner.hide()
    }

  }
  mangeCategory() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    this.dialog.open(VideoCategoryManageComponent, dialogConfig);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

}